import React from 'react'

type Props = {
  className?: string
}

export const OneIdSvg = (props: Props) => {
  return (
    <svg
      width="75"
      height="50"
      viewBox="0 0 75 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.0375 41.4044C19.0375 42.965 18.6477 44.3512 17.8679 45.5631C17.0882 46.775 15.9849 47.7255 14.5581 48.4144C13.1313 49.0951 11.4557 49.4354 9.53121 49.4354C7.59842 49.4354 5.91864 49.0909 4.49186 48.402C3.05679 47.713 1.94938 46.7667 1.16963 45.5631C0.389875 44.3512 6.8168e-08 42.965 0 41.4044C-6.8168e-08 39.8439 0.389875 38.4618 1.16963 37.2582C1.94938 36.0546 3.05679 35.1124 4.49186 34.4318C5.91864 33.7428 7.59842 33.3983 9.53121 33.3983C11.4557 33.3983 13.1313 33.7428 14.5581 34.4318C15.9849 35.1124 17.0882 36.0546 17.8679 37.2582C18.6477 38.4618 19.0375 39.8439 19.0375 41.4044ZM17.4573 41.4044C17.4573 40.1925 17.1421 39.1051 16.5116 38.1422C15.8812 37.1793 14.977 36.4198 13.7991 35.8636C12.6129 35.3075 11.1903 35.0294 9.53121 35.0294C7.86387 35.0294 6.43709 35.3075 5.25087 35.8636C4.06466 36.4198 3.15633 37.1793 2.52589 38.1422C1.89546 39.1051 1.58024 40.1925 1.58024 41.4044C1.58024 42.6163 1.89546 43.7079 2.52589 44.6791C3.15633 45.642 4.06466 46.4056 5.25087 46.9701C6.43709 47.5262 7.86387 47.8043 9.53121 47.8043C11.182 47.8043 12.6004 47.5262 13.7867 46.9701C14.9729 46.4139 15.8812 45.6544 16.5116 44.6915C17.1421 43.7203 17.4573 42.6246 17.4573 41.4044Z"
        fill="#003399"
      />
      <path
        d="M0.248855 15.6429L18.7887 15.6429V17.3114L3.27246 28.256V28.4178H18.7887V30.1112H0.248856L0.248856 28.4677L15.7899 17.4608V17.3239H0.248856L0.248855 15.6429Z"
        fill="#003399"
      />
      <path
        d="M18.7887 11.5092L0.248855 11.5092L0.248855 0.738892L1.77932 0.738892L1.77932 9.8158L8.69754 9.8158L8.69754 1.31165L10.2156 1.31165L10.2156 9.8158H17.2706V0.564575L18.7887 0.564575V11.5092Z"
        fill="#003399"
      />
      <path
        d="M49.8535 16.9935C46.4265 16.9935 43.6485 19.7734 43.6485 23.2026V50H50.0168C52.1 50 54.1239 49.7448 56.0585 49.264V23.2026C56.0585 19.7734 53.2804 16.9935 49.8535 16.9935Z"
        fill="#003399"
      />
      <path
        d="M75 25C75 34.3544 69.866 42.5088 62.2634 46.7954V3.20461C69.866 7.49125 75 15.6456 75 25Z"
        fill="#003399"
      />
      <path d="M37.4435 0H25.0335V50H37.4435V0Z" fill="#003399" />
      <path
        d="M56.385 6.37255C56.385 9.89201 53.5339 12.7451 50.0168 12.7451C46.4997 12.7451 43.6485 9.89201 43.6485 6.37255C43.6485 2.85309 46.4997 0 50.0168 0C53.5339 0 56.385 2.85309 56.385 6.37255Z"
        fill="#003399"
      />
    </svg>
  )
}
